import Parse from "parse"
import {
  actionWithLoader,
  push,
  onEnter,
  getReplacingPath,
} from "../../Utils/utils"
import {
  getDistributionCentersOrderByPriority,
} from "../../../parseManager/planning/parsePlanningManager"

export function planningSettingsDispatchPriorityChangeBrand(brand) {
  return actionWithLoader(async (dispatch) => {
    dispatch({
      type: "PLANNING_SETTINGS_DISTRIBUTION_CENTERS_UPDATE_BRAND",
      brand: brand
    })
  })
}

export const updateDistributionCentersDispatchPriority = (values) => {
  return actionWithLoader(async (dispatch) => {
    const hubs = values.distributionCenters.map((dc, index) => ({
      objectId: dc.objectId,
      priority: index + 1,
    }))

    await Parse.Cloud.run("updateDispatchPriority", { hubs })

    dispatch({
      type: "PLANNING_SETTINGS_SNACKBAR",
      planningSettingsSnackBar: {
        open: true,
        type: "success",
        message: "La priorité des centres de distribution a été mise à jour.",
        duration: 5000,
      },
    })
  })
}

export function loadPlanningSettingsDispatchPriority() {
  return actionWithLoader(async (dispatch) => {
    const distributionCenters = await getDistributionCentersOrderByPriority()
    dispatch({
      type: "PLANNING_SETTINGS_DISTRIBUTION_CENTERS_LIST_LOADED",
      distributionCenters: distributionCenters,
    })
  })
}

export function onEnterPlanningSettingsDispatchPriority(store) {
  return onEnter({
    store,
    actionThunk: loadPlanningSettingsDispatchPriority,
    getReplacingPath: getReplacingPath({ needUser: true }),
  })
}

export function showPlanningSettingsDispatchPriority() {
  return push("/settings/sites/dispatchPriority")
}
